import React, { useEffect, useState } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useLoadboardTheme } from './loadboardTheme'


export function Label({ children, required }) {
	const { tokens } = useLoadboardTheme()
	return (
		<label className={tokens.floatingLabel}>
			{children}
			{required && <span className="text-rose-500 ml-0.5">*</span>}
		</label>
	)
}


export function DeferredNumberInput({
	value,
	onCommit,
	placeholder,
	className,
	...rest
}) {
	const [draft, setDraft] = useState(
		value === '' || value == null ? '' : String(value)
	)

	useEffect(() => {
		setDraft(value === '' || value == null ? '' : String(value))
	}, [value])

	const commit = () => {
		if (draft === '') {
			if (value !== '') onCommit('')
			return
		}
		const n = Number(draft)
		const next = Number.isFinite(n) ? n : ''
		if (next !== value) onCommit(next)
	}

	const hasValue = draft !== ''

	return (
		<div className="relative w-full group">
			<style>{`
				input.ll-no-spin::-webkit-outer-spin-button,
				input.ll-no-spin::-webkit-inner-spin-button {
					-webkit-appearance: none;
					margin: 0;
				}
				input.ll-no-spin { -moz-appearance: textfield; }
			`}</style>
			<input
				type="number"
				value={draft}
				onChange={e => setDraft(e.target.value)}
				onBlur={commit}
				onKeyDown={e => {
					if (e.key === 'Enter') e.currentTarget.blur()
				}}
				placeholder={placeholder}
				className={`${className} ll-no-spin ${hasValue ? 'pr-4' : ''}`}
				{...rest}
			/>
			{hasValue && (
				<button
					type="button"
					tabIndex={-1}
					onMouseDown={e => e.preventDefault()}
					onClick={() => {
						setDraft('')
						if (value !== '') onCommit('')
					}}
					aria-label="Clear"
					className="absolute right-0 top-1/2 -translate-y-1/2 hidden group-hover:flex items-center justify-center h-4 w-4 text-gray-400 hover:text-gray-700"
				>
					<XMarkIcon className="h-3 w-3" strokeWidth={2.5} />
				</button>
			)}
		</div>
	)
}


export const makeInputBase = tokens =>
	`w-full bg-transparent text-[13px] ${tokens.inputText} ${tokens.placeholder} focus:outline-none`
